import { Component, Input, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { IAdmissionFile } from 'src/app/interfaces/AdmissionPatient/AdmissionProfile/IAdmissionFile';
import { ICoding } from 'src/app/interfaces/ICoding';
import { AdmissionService } from 'src/app/services/admission.service';
import { PatientService } from 'src/app/services/patient.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-admission-documents',
  templateUrl: './admission-documents.component.html',
  styleUrls: ['./admission-documents.component.css'],
  standalone: false,
})
export class AdmissionDocumentsComponent {
  patientId: string = '';
  @Input() fileList: ICoding[] = [];
  @Input() isEditMode: boolean = false;
  @Input() patientIdInput: string | null = null;

  documents: IAdmissionFile[] = [];

  constructor(
    private readonly patientService: PatientService,
    private readonly route: ActivatedRoute
  ) {}

  private destroy$ = new Subject<void>();

  ngOnInit() {
    this.patientService.documentsSub
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.documents = data;
      });

    if (!this.patientIdInput) {
      this.route.queryParams.subscribe((params) => {
        this.patientId = params['patientId'];

        this.patientService.getFiles(this.patientId);
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['admissionPersonalInfoData']) {
      // this.initializeForm();
    }
    if (changes['isEditMode']) {
      // this.setFormControlsState();
    }
  }

  getDocument(documentID: number) {
    return this.documents.find((d) => d.fileTypeId === documentID);
  }
}
